import {
    ADD_MESSAGES,
    SET_MESSAGES,
//    SET_USERS_COUNT,
//    SET_CURRENT_USER,
    SET_CONNECTION_ESTABLISHED,
    SET_CONNECTION_ID,
    UPDATE_QUESTIONS
} from './actionTypes';

export const messages = (state = [], {type, payload}) => {
    switch (type) {
        case ADD_MESSAGES:
            return [...state, ...payload];
        case SET_MESSAGES:
            return payload;
        case UPDATE_QUESTIONS:
            return state.map(
                item => payload.find(updatedItem => updatedItem.id === item.id && item.isQuestion) || item
            );
        default:
            return state;
    }
};


// export const users = (state = {}, {type, payload}) => {
//     switch (type) {
//         case SET_USERS_COUNT:
//             return Object.assign({}, state, { count: payload });
//         case SET_CURRENT_USER:
//             return Object.assign({}, state, {
//                     current: Object.assign({}, state.current, payload)
//                 });
//         default:
//             return state;
//     }
// };

export const ui = (state = [], {type, payload}) => {
    switch (type) {
        case SET_CONNECTION_ESTABLISHED:
            return Object.assign({}, state, { connectionEstablished: payload });
        case SET_CONNECTION_ID:
            return Object.assign({}, state, { connectionId: payload });
        default:
            return state;
    }
};
